import * as React from "react";
import Entity from "../metamodel/Entity";
import {FieldBehaviors, FieldType} from "../metamodel/IField";
import ArrayField from "../metamodel/Fields/ArrayField";
import ImageField from "../metamodel/Fields/ImageField";
import {Link} from "react-router-dom";
import PropertyDisplayFactory from "./PropertyDisplayFactory";
import * as H from 'history';

const createUrl = (location: H.Location, hash: string) => `${location.pathname}${location.search}#${hash}`;

export default class SearchResultComponentFactory {

    private propertyDisplayFactory: PropertyDisplayFactory = new PropertyDisplayFactory();

    public build(entity: Entity, history: H.History, page: number, data: any) {
        const idField = entity.fields.find(f => (f.behaviors & FieldBehaviors.Identification)!== 0);
        if (!idField) {
            throw new Error("An entity must have an identifier field");
        }
        const titleField = entity.fields.find(f => (f.behaviors & FieldBehaviors.Title)!== 0);
        if (!titleField) {
            throw new Error("An entity must have a title field");
        }
        const subTitleField = entity.fields.find(f => (f.behaviors & FieldBehaviors.SubTitle)!== 0);

        const imageUrl = this.getImageUrl(entity);
        const descriptionField = entity.fields.find(f => (f.behaviors & FieldBehaviors.Description)!== 0);
        if (!descriptionField) {
            throw new Error("An entity must have a description field");
        }
        // @ts-ignore
        const onDetailPageClick = (hash: string) => history.replace({...history.location, hash});

        const id = (data[idField.id]).replace(/\s/g,'_');
        const ignore = (e: any) => {
            e.preventDefault();
            return false;
        };
        const encode = (e: string) => encodeURIComponent(e);
        return <div key={data[idField.id]} id={id} className="col-xs-12">
            <div className="listing listing--list1">
                {imageUrl &&
                <div className="listing__media">
                    <Link onClick={onDetailPageClick.bind({}, id)} to={{
                        pathname: `/${entity.id}/${encode(data[idField.id])}`,
                        state: {returnUrl: createUrl(history.location, id)}
                    }}>
                        <img onContextMenu={ignore} src={imageUrl(data)} alt=""/>
                    </Link>
                </div>}
                <div className="listing__body">
                    <h3 className="listing__title">
                        <Link onClick={onDetailPageClick.bind({}, id)} to={{
                            pathname: `/${entity.id}/${encode(data[idField.id])}`,
                            state: {returnUrl: createUrl(history.location, id)}
                        }}>{data[titleField.id].normalize()}</Link>
                        <br/><small>{subTitleField ? this.propertyDisplayFactory.build(subTitleField, data) : undefined}</small>
                    </h3>
                    <div className="listing__content">
                        {data[descriptionField.id] && data[descriptionField.id].normalize()}
                    </div>
                    <div className="item__actions">
                        <div className="tb">
                            <div className="tb__cell cell-large">
                                <Link className="listgo-btn btn-primary" onClick={onDetailPageClick.bind({}, id)} to={{
                                    pathname: `/${entity.id}/${encode(data[idField.id])}`,
                                    state: {returnUrl: createUrl(history.location, id)}
                                }}>Bekijk</Link>
                            </div>
                            <div className="tb__cell cell-large"/>
                            <div className="tb__cell"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>;
    }


    private getImageUrl(entity: Entity): ((data: any) => string) | undefined {
        const imageField = entity.fields.find(f => f.type === FieldType.Image || (f.type === FieldType.Array && (f as ArrayField).innerField.type === FieldType.Image));
        if (!imageField) {
            return undefined;
        }
        if (imageField.type === FieldType.Array) {
            const baseUrl = ((imageField as ArrayField).innerField as ImageField).baseUrl;
            return (data) => {
                const filename = data[imageField.id][0];
                const extension = filename.indexOf('.jpg', filename.length - 4) !== -1 ? "" : ".jpg";
                return`${baseUrl}${filename}${extension}`;
            };
        } else {
            const baseUrl = (imageField as ImageField).baseUrl;
            return (data) => {
                const filename = data[imageField.id];
                const extension = filename.indexOf('.jpg', filename.length - 4) !== -1 ? "" : ".jpg";
                return`${baseUrl}${filename}${extension}`;
            };
        }
    }

}


// WEBPACK FOOTER //
// ./src/factories/SearchResultComponentFactory.tsx